// App wide configuration goes here
// import packageJSON from '../../package.json';

// default selected map layer(s) to display when the app loads
export const DEFAULT_LAYERS = ['global_aef'];

// mobile width breakpoint
export const MOBILE_BREAKPOINT_WIDTH = 420;

// url to assets on S3 bucket
export const s3Url = 'https://s3-us-west-2.amazonaws.com/canopyplanet';



// WEBPACK FOOTER //
// ./src/common/config.js